import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Facilities from './components/Facilities';
import Process from './components/Process';
import Clients from './components/Clients';
import Contact from './components/Contact';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToContact = () => {
    const quoteForm = document.getElementById('quote-form-section');
    if (quoteForm) {
      quoteForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white ${scrolled ? 'shadow-md' : ''}`}>
        <nav className="container mx-auto px-4">
          <div className="flex items-center justify-between h-20">
            <div className="flex items-center gap-2">
              <img 
                src="https://static.readdy.ai/image/2de9e8192ae00a75b7d7b36ef2548e1c/ef086ae9ec2bce650ec4c5a592dcdbcd.png" 
                alt="LOGIVIEW 로고" 
                className="h-16 w-auto"
              />
            </div>
            
            <ul className="hidden md:flex items-center gap-8">
              {['홈', '서비스', '회사소개', '인프라', '문의하기'].map((item, idx) => (
                <li key={idx}>
                  <a
                    href={`#${['home', 'services', 'about', 'facilities', 'contact'][idx]}`}
                    className="font-medium transition-colors hover:text-cyan-600 cursor-pointer text-gray-700"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>

            <button className="md:hidden text-2xl" aria-label="메뉴">
              <i className="fas fa-bars text-gray-900"></i>
            </button>
          </div>
        </nav>
      </header>

      <Hero />
      <Services />
      <About />
      <Facilities />
      <Process />
      <Clients />
      <Contact />

      <footer className="bg-slate-800 text-white py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
            <div className="lg:col-span-2">
              <div className="flex items-center gap-2 text-2xl font-bold mb-4">
                <span>LOGI<strong>VIEW</strong></span>
              </div>
              <p className="text-gray-400 mb-6">
                스마트 물류의 새로운 기준<br />
                고객과 함께 성장하는 물류 파트너
              </p>
              <div className="flex gap-4">
                {['facebook', 'instagram', 'youtube'].map((social) => (
                  <a
                    key={social}
                    href="#"
                    className="w-10 h-10 rounded-full bg-slate-700 flex items-center justify-center hover:bg-cyan-600 transition-colors cursor-pointer"
                    aria-label={social}
                  >
                    <i className={`fab fa-${social}`}></i>
                  </a>
                ))}
                <a
                  href="#"
                  className="w-10 h-10 rounded-full bg-slate-700 flex items-center justify-center hover:bg-cyan-600 transition-colors cursor-pointer"
                  aria-label="blog"
                >
                  <i className="fas fa-blog"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">서비스</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#services" className="hover:text-white transition-colors cursor-pointer">보관/입출고</a></li>
                <li><a href="#services" className="hover:text-white transition-colors cursor-pointer">유통가공</a></li>
                <li><a href="#services" className="hover:text-white transition-colors cursor-pointer">배송대행</a></li>
                <li><a href="#services" className="hover:text-white transition-colors cursor-pointer">풀필먼트</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">회사정보</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#about" className="hover:text-white transition-colors cursor-pointer">회사소개</a></li>
                <li><a href="#facilities" className="hover:text-white transition-colors cursor-pointer">인프라</a></li>
                <li><a href="#contact" className="hover:text-white transition-colors cursor-pointer">문의하기</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">채용정보</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">고객지원</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">공지사항</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">FAQ</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">이용약관</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">개인정보처리방침</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-slate-700 pt-8 text-center text-gray-400 text-sm">
            <p>© 2026 LogiView. All rights reserved. | 사업자등록번호: 505-86-02981 | <a href="https://readdy.ai/?ref=logo" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Website Builder</a></p>
          </div>
        </div>
      </footer>

      {/* 문의하기 플로팅 버튼 */}
      {showScrollTop && (
        <button
          onClick={scrollToContact}
          className="fixed bottom-24 right-8 w-14 h-14 bg-cyan-600 text-white rounded-full shadow-lg hover:bg-cyan-700 transition-all cursor-pointer flex items-center justify-center group"
          aria-label="문의하기"
        >
          <i className="fas fa-comment-dots text-xl"></i>
          <span className="absolute right-16 bg-gray-900 text-white px-3 py-1 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
            문의하기
          </span>
        </button>
      )}

      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 w-12 h-12 bg-cyan-600 text-white rounded-full shadow-lg hover:bg-cyan-700 transition-all cursor-pointer flex items-center justify-center"
          aria-label="맨 위로"
        >
          <i className="fas fa-chevron-up"></i>
        </button>
      )}
    </div>
  );
}